import { tracker } from '@openreplay/tracker';

let isInitialized = false;
export const openReplayKey = (window as any)?.env?.VITE_OPENREPLAY_KEY;
export const openReplayIngestPoint = 'https://openreplay.sanaap.co/ingest';

export const initOpenReplay = () => {
  if (!openReplayKey || isInitialized) return;

  isInitialized = true;

  tracker.configure({
    projectKey: openReplayKey,
    ingestPoint: openReplayIngestPoint,
    defaultInputMode: 2,
    respectDoNotTrack: true,
  });

  Promise.resolve()
    .then(() => tracker.start())
    .catch(() => undefined);
};
